import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'

// -----------------------------------------------------------------------------
// API Calls

function fetchSOVNetworks (category, categoryDate) {
  let body = {
    date: categoryDate
  }
  return utils.makeApiCall({
    url: `/api/insights/sov/networks/average/${category}`,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_SOV_NETWORKS,
    actionReceive: ActionTypes.RECEIVE_SOV_NETWORKS,
    actionFailure: ActionTypes.REQUEST_SOV_NETWORKS_FAILURE,
    authenticated: true,
    actionProps: {
      category: category
    }
  })
}

function fetchSOVCotentRank (category, date, thumbnail) {
  let body = {
    date: date,
    thumbnail: thumbnail
  }
  return utils.makeApiCall({
    url: `/api/v2/insights/sov/content/rank/average/${category}`,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_SOV_CONTENT_RANK,
    actionReceive: ActionTypes.RECEIVE_SOV_CONTENT_RANK,
    actionFailure: ActionTypes.REQUEST_SOV_CONTENT_RANK_FAILURE,
    authenticated: true,
    actionProps: {
      category: category,
      date: date,
      thumbnail: thumbnail
    }
  })
}

function fetchSOVCotentRankByScore (category, date, thumbnail) {
  let body = {
    date: date,
    thumbnail: thumbnail
  }
  return utils.makeApiCall({
    url: `/api/v2/insights/sov/content/rank/average/${category}`,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_SOV_CONTENT_RANK_SCORE,
    actionReceive: ActionTypes.RECEIVE_SOV_CONTENT_RANK_SCORE,
    actionFailure: ActionTypes.REQUEST_SOV_CONTENT_RANK_SCORE_FAILURE,
    authenticated: true,
    actionProps: {
      category: category,
      date: date,
      thumbnail: thumbnail
    }
  })
}

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchSOVNetworksIfNeeded (category, categoryDate) {
  return (dispatch, getState) => {
    const state = (getState().sov.byCategory[category] || {}).networks
    if (utils.shouldFetch(state) || (state && state.details && state.details.length === 0)) {
      return dispatch(fetchSOVNetworks(category, categoryDate))
    }
    return Promise.resolve()
  }
}

export function fetchSOVCotentRankIfNeeded (category, date, thumbnail) {
  return (dispatch, getState) => {
    const state = (getState().sov.byCategory[category] || {})[date]
    if (utils.shouldFetch(state)) {
      return dispatch(fetchSOVCotentRank(category, date, thumbnail))
    }
    return Promise.resolve()
  }
}

export function fetchSOVCotentRankByScoreIfNeeded (category, date, thumbnail) {
  return (dispatch, getState) => {
    const state = ((getState().sov.byCategory[category] && getState().sov.byCategory[category].contentRankByScore) || {})[date]
    if (utils.shouldFetch(state)) {
      return dispatch(fetchSOVCotentRankByScore(category, date, thumbnail))
    }
    return Promise.resolve()
  }
}

export function setSelectedCategory (category) {
  return {
    type: ActionTypes.SOV_SELECTED_CATEGORY,
    category
  }
}

export function setSelectedMetricDate (date) {
  return {
    type: ActionTypes.SOV_SELECTED_METRIC_DATE,
    date
  }
}
